export default __webpack_public_path__ + "static/media/2.d3762604.jpg";